






import Vue from "vue";
import {Prop, Component, Watch} from 'vue-property-decorator'
import { PaintingByNumbersModule } from '@/store/modules/paintingByNumbers'
import { DesignApi, Configuration } from '@/rest'
import { AppModule } from '@/store/modules/app'

@Component({
  name: "box-image",
})
export default class Tab extends Vue {
  @Prop() private assetId!: number
  @Prop() private designNr!: number
  @Prop() private name!: string
  @Prop() private designCategoryId!: number
  @Prop() private index!: number

  private hash: string = ""
  private timestamp: string = ""

  isSelectedDesign() {
    return PaintingByNumbersModule.boxDesign === this.designNr
  }

  onSelectDesign() {
    PaintingByNumbersModule.SetBoxDesign(this.designNr)
    PaintingByNumbersModule.SetBoxDesignCategory(this.designCategoryId)
  }

  createTimestamp() {
    let date = new Date();
    this.timestamp = date.getUTCFullYear().toString() 
        + ((date.getUTCMonth() + 1) > 9 ? '' : '0') + (date.getUTCMonth() + 1).toString() 
        + ((date.getUTCDate() + 1) > 9 ? '' : '0') + date.getUTCDate().toString() 
        + (date.getUTCHours() > 9 ? '' : '0') +  date.getUTCHours().toString() 
        + (date.getUTCMinutes() > 9 ? '' : '0') + date.getUTCMinutes().toString()
        + (date.getUTCSeconds() > 9 ? '' : '0') + date.getUTCSeconds().toString()
  }

  get link() {
    if(this.hash) {
      let url = '/cpapi/design/asset/'
      url += this.sessionId
      url += '/'
      url += this.assetId
      url += '?hash=' + this.hash
      url += '&timestamp=' + this.timestamp
      return url
    }
    return ""
  }

  get sessionId() {
      if(AppModule.session && AppModule.session.sessionId) {
        return AppModule.session.sessionId
      }
      return ""
  }

  getHash(): Promise<void> {
    var self = this
    this.createTimestamp()
    let path = '/cpapi/design/asset/' + this.sessionId + '/' + this.assetId
    return new Promise<void>((resolve, reject) => {
        let designApi = new DesignApi(
            new Configuration({ basePath: '/rest'})
        )
        let generateHashRequest = {"value":path, "timestamp":self.timestamp};
        designApi.generateHash(generateHashRequest).then(
            (value) => {
                self.hash = value
                resolve()
            },
            (reason) => {
                window.console.log(reason)
                reject()
            });
      });
  }

  mounted() {
    this.getHash()
  }

}
